var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card card-custom gutter-b bg-white border-0" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-3" }, [
            _c(
              "ul",
              {
                staticClass: "nav flex-column nav-pills mb-3",
                attrs: {
                  id: "v-pills-tab1",
                  role: "tablist",
                  "aria-orientation": "vertical",
                },
              },
              [
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.isActive("general") },
                      attrs: { href: "#general" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.setActive("general")
                        },
                      },
                    },
                    [_vm._v("General")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.isActive("businesslocation") },
                      attrs: { href: "#businesslocation" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.setActive("businesslocation")
                        },
                      },
                    },
                    [_vm._v("Business Country")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.isActive("chooselanguage") },
                      attrs: { href: "#chooselanguage" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.setActive("chooselanguage")
                        },
                      },
                    },
                    [_vm._v("Choose Languages")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.isActive("choosecurrencies") },
                      attrs: { href: "#choosecurrencies" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.setActive("choosecurrencies")
                        },
                      },
                    },
                    [_vm._v("Choose Currencies")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.isActive("chooseTimezone") },
                      attrs: { href: "#chooseTimezone" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.setActive("chooseTimezone")
                        },
                      },
                    },
                    [_vm._v("Choose TimeZone")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.isActive("emailsmtp") },
                      attrs: { href: "#emailsmtp" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.setActive("emailsmtp")
                        },
                      },
                    },
                    [_vm._v("Email SMTP Settings")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.isActive("sms") },
                      attrs: { href: "#sms" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.setActive("sms")
                        },
                      },
                    },
                    [_vm._v("SMS")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.isActive("notification") },
                      attrs: { href: "#notification" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.setActive("notification")
                        },
                      },
                    },
                    [_vm._v("Notification")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.isActive("invoice") },
                      attrs: { href: "#invoice" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.setActive("invoice")
                        },
                      },
                    },
                    [_vm._v("INVOICE")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.isActive("EmailTemplate") },
                      attrs: { href: "#EmailTemplate" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.setActive("EmailTemplate")
                        },
                      },
                    },
                    [_vm._v("\n              Email Template\n            ")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.isActive("credentials") },
                      attrs: { href: "#credentials" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.setActive("credentials")
                        },
                      },
                    },
                    [_vm._v("\n              Consumer Keys\n            ")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.isActive("firebase") },
                      attrs: { href: "#firebase" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.setActive("firebase")
                        },
                      },
                    },
                    [_vm._v("\n              Firebase\n            ")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.isActive("google") },
                      attrs: { href: "#google" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.setActive("google")
                        },
                      },
                    },
                    [_vm._v("\n              Google\n            ")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.isActive("points") },
                      attrs: { href: "#points" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.setActive("points")
                        },
                      },
                    },
                    [_vm._v("\n              Points\n            ")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.isActive("wallet") },
                      attrs: { href: "#wallet" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.setActive("wallet")
                        },
                      },
                    },
                    [_vm._v("\n              Wallet\n            ")]
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-9" }, [
            _c(
              "div",
              {
                staticClass: "tab-content",
                attrs: { id: "v-pills-tabContent1" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade",
                    class: { "active show": _vm.isActive("general") },
                  },
                  [
                    _c("General", {
                      on: { updateLoadingState: _vm.updateLoadingState },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade",
                    class: { "active show": _vm.isActive("businesslocation") },
                  },
                  [
                    _c("BusinessLocation", {
                      on: { updateLoadingState: _vm.updateLoadingState },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade",
                    class: { "active show": _vm.isActive("chooselanguage") },
                  },
                  [
                    _c("ChooseLanguage", {
                      on: { updateLoadingState: _vm.updateLoadingState },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade",
                    class: { "active show": _vm.isActive("choosecurrencies") },
                  },
                  [
                    _c("ChooseCurrencies", {
                      on: { updateLoadingState: _vm.updateLoadingState },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade",
                    class: { "active show": _vm.isActive("chooseTimezone") },
                  },
                  [
                    _c("TimeZone", {
                      on: { updateLoadingState: _vm.updateLoadingState },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade",
                    class: { "active show": _vm.isActive("emailsmtp") },
                  },
                  [
                    _c("EmailSmtp", {
                      on: { updateLoadingState: _vm.updateLoadingState },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade",
                    class: { "active show": _vm.isActive("sms") },
                  },
                  [
                    _c("Sms", {
                      on: { updateLoadingState: _vm.updateLoadingState },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade",
                    class: { "active show": _vm.isActive("notification") },
                  },
                  [
                    _c("Notification", {
                      on: { updateLoadingState: _vm.updateLoadingState },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade",
                    class: { "active show": _vm.isActive("invoice") },
                  },
                  [
                    _c("Invoice", {
                      on: { updateLoadingState: _vm.updateLoadingState },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade",
                    class: { "active show": _vm.isActive("EmailTemplate") },
                  },
                  [
                    _c("EmailTemplate", {
                      on: { updateLoadingState: _vm.updateLoadingState },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade",
                    class: { "active show": _vm.isActive("credentials") },
                  },
                  [
                    _c("ConsumerKeys", {
                      on: { updateLoadingState: _vm.updateLoadingState },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade",
                    class: { "active show": _vm.isActive("firebase") },
                  },
                  [
                    _c("Firebase", {
                      on: { updateLoadingState: _vm.updateLoadingState },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade",
                    class: { "active show": _vm.isActive("google") },
                  },
                  [
                    _c("Google", {
                      on: { updateLoadingState: _vm.updateLoadingState },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade",
                    class: { "active show": _vm.isActive("points") },
                  },
                  [
                    _c("points", {
                      on: { updateLoadingState: _vm.updateLoadingState },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade",
                    class: { "active show": _vm.isActive("wallet") },
                  },
                  [
                    _c("Wallet", {
                      on: { updateLoadingState: _vm.updateLoadingState },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "card-header border-0 align-items-center" },
      [
        _c(
          "h3",
          { staticClass: "card-label mb-0 font-weight-bold text-body" },
          [_vm._v("\n      Bussiness Setting\n    ")]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }